export const MainLeakInvestigationAndRemediation = {
    "imageUrl": "/assets/imgs/services/10LeakInvestigationAndRemediation/fondo.png",
    "eyebrow": "Leak Investigation",
    "title": "& Remediation",
    "headingSpan": "DETECT, REPAIR",
    "heading": "& PROTECT",
    "description": "Unaddressed water leaks can lead to structural damage, mold growth, and costly repairs. At HRD Painting & Restoration, we specialize in comprehensive leak detection and remediation, identifying the root cause of water intrusion and applying long-lasting solutions to protect your building.",
    "highlightSpan": "The best Building Envelope Renewal",
    "highlight": " / High-Rise Painting & Restoration services.",
    "button": {
        "text": "Request a Quote",
        "url": "/quote"
    }
};